module.exports = __webpack_public_path__ + "static/media/precalculus-not-enrolled.56880da3.svg";